"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkActivity;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useMarkActivity() {
  return (0, _useWebChatAPIContext.default)().markActivity;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VNYXJrQWN0aXZpdHkuanMiXSwibmFtZXMiOlsidXNlTWFya0FjdGl2aXR5IiwibWFya0FjdGl2aXR5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQTJCO0FBQ3hDLFNBQU8scUNBQXVCQyxZQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZU1hcmtBY3Rpdml0eSgpIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkubWFya0FjdGl2aXR5O1xufVxuIl19